import realtime from 'bui/realtime/client'
import RealtimeUsers from 'bui/realtime/client/realtime-users'

export default realtime

RealtimeUsers.realtime = realtime